

import kr from '../../kr/kr';
import HTMLClass from '../../kr/utils/HTMLClass';

export default class SearchInput extends kr.Component {
    init()
    {
        this.$products = document.querySelectorAll('.js-forarchitectItem');
        this.searchText = null;

        this.bind();
    }

    bind()
    {
        this.$element.addEventListener('change', () => {
            this.searchText = this.$element.value ? this.$element.value.toLowerCase() : null;
            if (this.searchText) {
                HTMLClass.addClass(this.$element, 'has-value');
            } else {
                HTMLClass.removeClass(this.$element, 'has-value');
            }
            this.app.dom.$window.dispatchEvent(this.app.getEvent('filter_cancel'));
            this._filterProducts();
        });
        this.$element.addEventListener('click', () => {
            HTMLClass.addClass(this.$element, 'has-value');
        });
        this.app.dom.$window.addEventListener('filter_clicked', () => {
            this.searchText = null;
            HTMLClass.removeClass(this.$element, 'has-value');
            this.$element.value = '';
        });
    }

    _filterProducts()
    {
        this.$products.forEach(item => {
            const title = item.querySelector('.product__title').textContent.replace(/[\n\r]+|[\s]{2,}/g, ' ').trim().toLowerCase();
            if (!this.searchText || title.includes(this.searchText)) {
                item.style.display = "block";
            } else {
                item.style.display = "none";
            }
        });
    }
}

kr.registerComponent('.js-forarchitectSearchInput', {
    component: SearchInput
});
